

exports.__esModule = true;
exports.SplitScreen = undefined;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

/*
 * This function decides the experience on xoon based on url parameters
 * passed by UL/hermes team
 * return value meaning
 * isULSplitScreenExp - UL page was on split screen experience - pxp treatment
 * isAccountMatched - UL triggered accountMatch on user entered email and
 *                    they found a valid member account
 * userChoseGuest - user directly clicked on "continue as guest" button on
 *                  respective UL page - ulPage=email/pwd
 */
var SplitScreen = exports.SplitScreen = {
    getSplitScreenExperience: function getSplitScreenExperience() {
        /*
         * Values - email/pwd/noMatch
         * email - redirect from Split Screen first page - enter email page
         *      user clicked on 'create as guest' button on email page
         * pwd - redirect from Split Screen second page - enter password page
         *      user clicked on 'create as guest' button on password page
         * noMatch - redirect from Split Screen first page - enter email page
         *      user entered email and there was no matching member account found
         *      So, user got redirected to xoon automatically from UL
         */
        var ulPage = _squid.$util.param('ulPage');
        var ulPageOptions = ['noMatch', 'pwd'];

        // check for all possible values, as we dont want some random
        // value on ulPage to enable splitscreen flow
        if (ulPage && ulPageOptions.indexOf(ulPage) > -1) {

            _logger.$logger.info('checkout_fpti', {
                source_decisioning: ulPage
            });

            // userChoseGuest Param Description
            // If not equal to noMatch - means the user is not automatically
            // redirected to xoon, but user clicked on a button or link to
            // land on xoon, which means userChoseGuest
            return {
                isULSplitScreenExp: true,
                isAccountMatched: ulPage === 'pwd' ? true : false,
                userChoseGuest: ulPage !== 'noMatch' ? true : false
            };
        }

        // Default return values which disables all splitscreen features
        return {
            isULSplitScreenExp: false,
            isAccountMatched: false,
            userChoseGuest: false
        };
    }
};

_squid.$util;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/lib/commonLib.js
// module id = ./components/xo-guest-components/src/guest/lib/commonLib.js
// module chunks = 1